import './EmptySearch.scss';
import { ComponentType, ReactNode } from 'react';
import { IconBaseProps } from 'react-icons/lib';
import { MdSearchOff } from 'react-icons/md';
import { Brand50 } from '../../../utils/colors';

interface EmptySearchProps {
  icon?: ComponentType<IconBaseProps>;
  label?: string;
}

export const EmptySearch = ({
  icon: Icon = MdSearchOff,
  label = 'No results'
}: EmptySearchProps): ReactNode => (
  <div className='empty-search-container' data-testid='empty-search-container'>
    <Icon color={Brand50} size={40} className='empty-search-icon' />
    <span className='empty-search-label'>{label}</span>
  </div>
);
